import type { InjectionKey, Ref } from 'vue';

export const SW_NEED_REFRESH_KEY: InjectionKey<Ref<boolean>> =
  Symbol('swNeedRefresh');

export const SW_UPDATE_SERVICE_WORKER_KEY: InjectionKey<
  (reloadPage?: boolean) => Promise<void>
> = Symbol('swUpdateServiceWorker');

export const SW_APPLY_UPDATE_KEY: InjectionKey<() => void> =
  Symbol('swApplyUpdate');

export type ServiceWorkerEventType =
  | 'manual-update-requested'
  | 'register-error'
  | 'update-check-failed'
  | 'update-available'
  | 'update-flow-entered'
  | 'waiting-missing'
  | 'update-rejected'
  | 'activation-timeout'
  | 'controller-change-reload'
  | 'chunk-error'
  | 'reload-guard-cooldown'
  | 'reload-guard-exhausted';

export interface ServiceWorkerEvent {
  type: ServiceWorkerEventType;
  message?: string;
  data?: Record<string, unknown>;
}

export type ServiceWorkerEventHandler = (event: ServiceWorkerEvent) => void;
